module.exports = __webpack_public_path__ + "img/import-files-hover.af8c8dcc.svg";